import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const giteaActionsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    EntityContentBlueprint.make({
      name: 'gitea-actions',
      params: {
        path: '/ci-cd',
        title: 'CI/CD',
        group: 'delivery',
        icon: <PlayCircleOutlineIcon />,
        filter: 'kind:component',
        loader: () =>
          import('./GiteaActionsPage').then(m => <m.GiteaActionsPage />),
      },
    }),
  ],
});
